module.exports = __webpack_public_path__ + "img/mtt_1.5.1e6a5184.png";